import { ExistingPatient } from '../../types';
import { PatientsListRequestSection } from './PatientsListRequestSection';

interface PatientRequestsAccordionProps {
  patient: ExistingPatient;
}

const PatientRequestsAccordion = ({
  patient,
}: PatientRequestsAccordionProps) => {
  const requests = patient.requests?.filter(
    (request) => request.services.length > 0,
  );

  if (!requests || requests.length === 0) {
    return (
      <div className="space-y-4 bg-gray-50 p-6">
        <div className="py-4 text-center text-gray-500">
          No requests found for this patient.
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4 bg-gray-50 p-6">
      {requests.map((request, index) => (
        <PatientsListRequestSection
          key={
            request.crrId ??
            request.services?.[0]?.id?.toString() ??
            `request-${index}`
          }
          request={request}
          patient={patient}
        />
      ))}
    </div>
  );
};

export default PatientRequestsAccordion;
